import { gql, useMutation } from '@apollo/client';

import { DialogType, useDialog } from '../../../dialogs/DialogManager';
import { errorToast } from '../../../toast';

export const useCancelVisitRequest = ({ visitRequestId }: { visitRequestId: string }) => {
    const { openDialog } = useDialog();

    // Mutations.
    const [doCancelVisitRequestMutation, { loading, error }] = useMutation(
        CANCEL_VISIT_REQUEST_MUTATION,
        {
            variables: { visitRequestId },
            onError: (error) => {
                if (error instanceof Error) {
                    errorToast(error.message);
                }
            },
            refetchQueries: 'active',
        },
    );

    function confirmCancelVisitRequest() {
        openDialog(DialogType.Confirm, {
            dataTestId: 'confirm-cancel-visit-request-dialog',
            title: 'Cancel Visit Request',
            message: 'Are you sure you want to cancel this visit request?',
            confirmCta: 'Cancel',
            cancelCta: 'Back',
            onConfirm: () => {
                void doCancelVisitRequestMutation();
            },
        });
    }

    return {
        cancelVisitRequest: ({ confirm = true }: { confirm?: boolean } | undefined = {}) => {
            if (confirm) {
                return confirmCancelVisitRequest();
            } else {
                return doCancelVisitRequestMutation();
            }
        },
        loading,
        error,
    };
};

const CANCEL_VISIT_REQUEST_MUTATION = gql`
    mutation CancelVisitRequest($visitRequestId: UUID!) {
        cancelVisitRequest(visitRequestId: $visitRequestId) {
            id
            state
            workflowStep
            order {
                id
                numActiveOccurrences
            }
        }
    }
`;
